import { render, staticRenderFns } from "./expenseNameManagement.vue?vue&type=template&id=b849c38a&scoped=true"
import script from "./expenseNameManagement.vue?vue&type=script&lang=js"
export * from "./expenseNameManagement.vue?vue&type=script&lang=js"
import style0 from "./expenseNameManagement.vue?vue&type=style&index=0&id=b849c38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b849c38a",
  null
  
)

export default component.exports